import { useCallback } from "react";
import { clearCurrentTask } from "reducers/files";
import {
  setShowErrorModal,
  setShowSendToOpsModal,
  setShowTaskModal,
} from "reducers/main";
import { useDispatch, useSelector } from "utils/redux";

/* centralize task board modal visibility and close handlers.
   keeps ui components focused on rendering. */
export const useTaskModalState = () => {
  const dispatch = useDispatch();
  const showTaskModal = useSelector((state) => state.main.showTaskModal);
  const showErrorModal = useSelector((state) => state.main.showErrorModal);
  const showSendToOpsModal = useSelector(
    (state) => state.main.showSendToOpsModal,
  );

  const handleCloseTaskModal = useCallback(() => {
    dispatch(clearCurrentTask());
    dispatch(setShowTaskModal(false));
  }, [dispatch]);

  const handleCloseSendToOpsModal = useCallback(() => {
    dispatch(setShowSendToOpsModal(false));
  }, [dispatch]);

  const handleCloseErrorModal = useCallback(() => {
    dispatch(setShowErrorModal(false));
  }, [dispatch]);

  return {
    showErrorModal,
    showSendToOpsModal,
    showTaskModal,
    handleCloseErrorModal,
    handleCloseSendToOpsModal,
    handleCloseTaskModal,
  };
};
